import { render } from "./modal-plane-auto-v3.vue?vue&type=template&id=475f686d&ts=true"
import script from "./modal-plane-auto-v3.vue?vue&type=script&lang=ts"
export * from "./modal-plane-auto-v3.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__